import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import errorSlice from "../../Services/errorSlice";
import departmentDetailService from "../../Services/departmentDetail.service";
import { alertSnackbarError, alertSnackbarSuccess } from "./alertStatusSlice";

const initialState = {
  loading: false,
  result: [],
};
export const departmentDetailList = createAsyncThunk(
  "departmentDetail/list",
  async (values, thunkAPI) => {
    try {
      const result = await departmentDetailService
        .list(values)
        .then((response) => {
          const { data } = response;
          return data.result;
        });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);
export const departmentDetailCreate = createAsyncThunk(
  "departmentDetail/create",
  async (values, thunkAPI) => {
    try {
      const result = await departmentDetailService
        .create(values)
        .then((response) => {
          const { data } = response;
          if (data.status === true) {
            thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
          } else {
            thunkAPI.dispatch(alertSnackbarError(data.msg));
          }
          return data;
        });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);
export const departmentDetailUpdate = createAsyncThunk(
  "departmentDetail/update",
  async (values, thunkAPI) => {
    try {
      const result = await departmentDetailService
        .update(values)
        .then((response) => {
          const { data } = response;
          if (data.status === true) {
            thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
          } else {
            thunkAPI.dispatch(alertSnackbarError(data.msg));
          }
          return data;
        });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);
export const departmentDetailDelete = createAsyncThunk(
  "departmentDetail/delete",
  async (values, thunkAPI) => {
    try {
      const result = await departmentDetailService
        .destroy(values)
        .then((respone) => {
          const { data } = respone;
          if (data.status === true) {
            thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
          } else {
            thunkAPI.dispatch(alertSnackbarError(data.msg));
          }
          return data;
        });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);

export const departmentDetailSlice = createSlice({
  name: "departmentDetailSlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(departmentDetailList.pending, (state, action) => {
      state.loading = true;
      state.result = [];
    });
    builder.addCase(departmentDetailList.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(departmentDetailList.rejected, (state, action) => {
      state.loading = false;
      state.result = [];
    });
  },
});

export const { reducer } = departmentDetailSlice.actions;

export default departmentDetailSlice.reducer;
